import { createWidget } from '@alfa-bank/site-util-create-widget';
import { ModalV2Desktop as ModalV2 } from '@alfa-bank/site-modal-v2/modal-desktop';
import { ModalV2HeaderDesktop as ModalV2Header } from '@alfa-bank/site-modal-v2/header-desktop';
import { ModalV2ContentDesktop as ModalV2Content } from '@alfa-bank/site-modal-v2/content-desktop';

import type { IDepsDesktop, TCalcWithModalDesktop } from '../models';

import { CalculatorWithModalDesktop as Component } from './component';

export const CalculatorWithModalDesktop = createWidget<IDepsDesktop, TCalcWithModalDesktop>({
    ModalV2,
    ModalV2Content,
    ModalV2Header,
})(Component);
